import { Cookie } from 'lucide-react';

import { cn } from '@/utils/cn';

import { useCookiePolicy } from './cookie-policy-store';

const CookiePolicy = () => {
  const { accepted, setAccepted } = useCookiePolicy();
  return (
    <div
      className={cn(
        accepted ? ['opacity-0', 'translate-y-40'] : ['opacity-100'],
        'fixed',
        'bottom-2',
        'left-1/2',
        '-translate-x-1/2',
        ['transition-all', 'duration-500'],
      )}
    >
      <div
        className={cn(
          // Size
          ['w-[820px]', 'max-w-[100vw]'],
          // Spacing
          ['px-4', 'py-2'],
          // Color
          ['bg-zinc-600', 'text-white'],
          'rounded-md',
          'drop-shadow-[0_0_5px_rgba(0,0,0,0.4)]',
          ['flex', 'flex-row', 'gap-4'],
        )}
      >
        <Cookie className="size-7 shrink-0 translate-y-1" />
        <div className="flex flex-col">
          <p className="text-base font-bold">Your privacy</p>
          <p className="mb-2 text-sm">
            In order to deliver personalized services and function effectively,
            this website will store cookies on your device. Please close this
            message and continue to use this site if you agree.
          </p>
          <div className="flex flex-row justify-end">
            <button
              className={cn(
                // Spacing
                ['px-2', 'py-1'],
                // Border
                ['border', 'border-zinc-200'],
                // Color
                ['bg-zinc-700', 'hover:bg-zinc-600'],
                'hover:font-bold',
                ['focus:ring-zinc-200', 'focus:ring-1'],
                'rounded-md',
                'text-sm',
                'shrink-0',
                ['transition-all', 'duration-200'],
              )}
              onClick={() => setAccepted()}
            >
              Accept & close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CookiePolicy.displayName = 'CookiePolicy';

export { CookiePolicy };
